module.exports = __webpack_public_path__ + "static/media/viewallMap.eed59504.svg";